//设置localStorage
export const setLocal = function (name, value) {
    localStorage.setItem(name, JSON.stringify(value));
}

//获取localStorage
export const getLocal = function (name) {
    return JSON.parse(localStorage.getItem(name));
}

//删除localStorage
export const removeLocal = function (name) {
    localStorage.removeItem(name);
}


// WEBPACK FOOTER //
// ./src/common/js/lib.js